<section>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="user-dashboard-info-box pb-0">
            <div id="chart">
            </div>
          </div>
          <div class="user-dashboard-info-box mb-0">
            <div class="section-title-02 mb-4">
              <h4>Job List</h4>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="job-list ">
                  <div class="job-list-logo">
                    <img class="img-fluid" src="assets/images/svg/01.svg" alt="">
                  </div>
                  <div class="job-list-details">
                    <div class="job-list-info">
                      <div class="job-list-title">
                        <h5 class="mb-0"><a href="job-detail.html">Marketing and Communications</a></h5>
                      </div>
                      <div class="job-list-option">
                        <ul class="list-unstyled">
                          <li> <span>via</span> <a href="employer-detail.html">Fast Systems Consultants</a> </li>
                          <li><i class="fas fa-map-marker-alt pr-1"></i>Wellesley Rd, London</li>
                          <li><i class="fas fa-filter pr-1"></i>Accountancy</li>
                          <li><a class="freelance" href="#"><i class="fas fa-suitcase pr-1"></i>Freelance</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="job-list-favourite-time"> <a class="order-2 mb-3 d-block" href="#"><i class="far fa-edit"></i></a> <span class="job-list-time order-1"><i class="far fa-clock pr-1"></i>1M ago</span> </div>
                </div>
              </div>
              <div class="col-12">
                <div class="job-list">
                  <div class="job-list-logo">
                    <img class="img-fluid" src="assets/images/svg/02.svg" alt="">
                  </div>
                  <div class="job-list-details">
                    <div class="job-list-info">
                      <div class="job-list-title">
                        <h5 class="mb-0"><a href="job-detail.html">Web Developer – .net</a></h5>
                      </div>
                      <div class="job-list-option">
                        <ul class="list-unstyled">
                          <li> <span>via</span> <a href="employer-detail.html">Pendragon Green Ltd</a> </li>
                          <li><i class="fas fa-map-marker-alt pr-1"></i>Needham, MA</li>
                          <li><i class="fas fa-filter pr-1"></i>IT &amp; Telecoms</li>
                          <li><a class="part-time" href="#"><i class="fas fa-suitcase pr-1"></i>Part-Time</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="job-list-favourite-time"> <a class="order-2 mb-3 d-block" href="#"><i class="far fa-edit"></i></a> <span class="job-list-time order-1"><i class="far fa-clock pr-1"></i>3D ago</span> </div>
                </div>
              </div>
              <div class="col-12">
                <div class="job-list">
                  <div class=" job-list-logo">
                    <img class="img-fluid" src="assets/images/svg/03.svg" alt="">
                  </div>
                  <div class="job-list-details">
                    <div class="job-list-info">
                      <div class="job-list-title">
                        <h5 class="mb-0"><a href="job-detail.html">Payroll and Office Administrator</a></h5>
                      </div>
                      <div class="job-list-option">
                        <ul class="list-unstyled">
                          <li> <span>via</span> <a href="employer-detail.html">Wight Sound Hearing LLC</a> </li>
                          <li><i class="fas fa-map-marker-alt pr-1"></i>New Castle, PA</li>
                          <li><i class="fas fa-filter pr-1"></i>Banking</li>
                          <li><a class="temporary" href="#"><i class="fas fa-suitcase pr-1"></i>Temporary</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="job-list-favourite-time"> <a class="order-2 mb-3 d-block" href="#"><i class="far fa-edit"></i></a> <span class="job-list-time order-1"><i class="far fa-clock pr-1"></i>2W ago</span> </div>
                </div>
              </div>
              <div class="col-12">
                <div class="job-list">
                  <div class="job-list-logo">
                    <img class="img-fluid" src="assets/images/svg/04.svg" alt="">
                  </div>
                  <div class="job-list-details">
                    <div class="job-list-info">
                      <div class="job-list-title">
                        <h5 class="mb-0"><a href="job-detail.html">Data Entry Administrator</a></h5>
                      </div>
                      <div class="job-list-option">
                        <ul class="list-unstyled">
                          <li> <span>via</span> <a href="employer-detail.html">Tan Electrics Ltd</a> </li>
                          <li><i class="fas fa-map-marker-alt pr-1"></i>Park Avenue, Mumbai</li>
                          <li><i class="fas fa-filter pr-1"></i>Charity &amp; Voluntary</li>
                          <li><a class="full-time" href="#"><i class="fas fa-suitcase pr-1"></i>Full-time</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="job-list-favourite-time"> <a class="order-2 mb-3 d-block" href="#"><i class="far fa-edit"></i></a> <span class="job-list-time order-1"><i class="far fa-clock pr-1"></i>3M ago</span> </div>
                </div>
              </div>
              <div class="col-12">
                <div class="job-list">
                  <div class="job-list-logo">
                    <img class="img-fluid" src="assets/images/svg/05.svg" alt="">
                  </div>
                  <div class="job-list-details">
                    <div class="job-list-info">
                      <div class="job-list-title">
                        <h5 class="mb-0"><a href="job-detail.html">Operational manager part-time</a></h5>
                      </div>
                      <div class="job-list-option">
                        <ul class="list-unstyled">
                          <li> <span>via</span> <a href="employer-detail.html">Fleet Home Improvements Pvt</a> </li>
                          <li><i class="fas fa-map-marker-alt pr-1"></i>Green Lanes, London</li>
                          <li><i class="fas fa-filter pr-1"></i>Accountancy (Qualified)</li>
                          <li><a class="part-time" href="#"><i class="fas fa-suitcase pr-1"></i>Part-Time</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="job-list-favourite-time"> <a class="order-2 mb-3 d-block" href="#"><i class="far fa-edit"></i></a> <span class="job-list-time order-1"><i class="far fa-clock pr-1"></i>6D ago</span> </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center mt-5">
                <ul class="pagination justify-content-center">
                  <li class="page-item disabled"> <span class="page-link b-radius-none">Prev</span> </li>
                  <li class="page-item active" aria-current="page"><span class="page-link">1 </span> <span class="sr-only">(current)</span></li>
                  <li class="page-item"><a class="page-link" href="#">2</a></li>
                  <li class="page-item"><a class="page-link" href="#">3</a></li>
                  <li class="page-item"><a class="page-link" href="#">...</a></li>
                  <li class="page-item"><a class="page-link" href="#">25</a></li>
                  <li class="page-item"> <a class="page-link" href="#">Next</a> </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>